import { TextField } from '@monorepo/shared/componentsV2/fields/TextField';
import { compose, makeIsNoLongerThan } from '@monorepo/shared/utils/validators';
import { FORM_TEMPLATE_GENERATION_CUSTOM_PROMPT_MAX_LENGTH } from 'mapistry-shared';
import React, { useEffect } from 'react';
import { useField } from 'react-final-form';
import styled from 'styled-components';

const StyledCustomPromptInput = styled(TextField)`
  width: 100%;
`;

const examplePrompt =
  "E.g. 'All field names should be uppercase.', or 'Create a form with two sections, the first one with a user, weather, and date field, and the second one with a notes field.'";

export function CustomPromptField({
  isProcessing,
  setCustomPrompt,
}: {
  isProcessing: boolean;
  setCustomPrompt: (customPrompt: string) => void;
}) {
  const {
    input: { value: customPromptFromFinalForm },
  } = useField<string>('customPrompt');

  // this is a frankenstein of a final form and a custom managed form because of how this got built quickly - do not copy this pattern
  useEffect(() => {
    setCustomPrompt(customPromptFromFinalForm);
  }, [customPromptFromFinalForm, setCustomPrompt]);

  return (
    <StyledCustomPromptInput
      label="Custom prompt (optional)"
      isLabelHidden
      disabled={isProcessing}
      name="customPrompt"
      placeholder={examplePrompt}
      validate={compose(
        makeIsNoLongerThan(FORM_TEMPLATE_GENERATION_CUSTOM_PROMPT_MAX_LENGTH),
      )}
      dontSaveSpaceForErrorText
      // multiline props
      multiline
      isResizable
      rowsMax={20}
    />
  );
}
